<div class="pie-chart" id="chart" (window:resize)="onResize($event)"></div>
